// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2c73X","index":"styles_index__3YsTm"};